var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 0H2.5C1.11929 0 0 1.11929 0 2.5V12.5C0 13.8807 1.11929 15 2.5 15H17.5C18.8807 15 20 13.8807 20 12.5V2.5C20 1.11929 18.8807 0 17.5 0ZM1.25 2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H17.5C18.1904 1.25 18.75 1.80964 18.75 2.5V12.5C18.75 13.1904 18.1904 13.75 17.5 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V2.5Z",
    fill: "#FCF2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3639 0.758539C18.6353 0.545281 19.0282 0.59243 19.2415 0.86385C19.431 1.10511 19.4148 1.44237 19.2183 1.66411L19.1362 1.74144L12.6901 6.80619L17.317 11.433C17.561 11.6771 17.561 12.0729 17.317 12.3169C17.1 12.5339 16.7632 12.558 16.5196 12.3892L16.4331 12.3169L11.7002 7.58401L10.3862 8.61644C10.1919 8.76907 9.92978 8.79087 9.71613 8.68185L9.61389 8.61644L8.29989 7.58401L3.56697 12.3169C3.32289 12.561 2.92716 12.561 2.68308 12.3169C2.46613 12.1 2.44202 11.7632 2.61077 11.5196L2.68308 11.433L7.30994 6.80619L0.863888 1.74144C0.592468 1.52818 0.545319 1.13527 0.758578 0.86385C0.948141 0.622588 1.27965 0.558527 1.54161 0.697049L1.63617 0.758539L10 7.32999L18.3639 0.758539Z",
    fill: "#FCF2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0a13da911c8612e10eabbd94463ebb48.svg";
export { ForwardRef as ReactComponent };